<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import {
    contactChannelTagsForContactPoint,
    noActiveChannelsTooltip,
  } from "../../_shared/_logic/contact-channels"

  interface Props {
    contact: ContactPoint
  }

  let { contact }: Props = $props()

  const tags = $derived(contactChannelTagsForContactPoint(contact))
</script>

<span class="contact-channel-tags">
  {#if tags.length}
    {#each tags as tag (tag.channel)}
      <StatusTag
        variant="neutral"
        size="sm"
        label={tag.label}
        color={tag.color}
        tooltipContent={tag.tooltip}
      />
    {/each}
  {:else}
    <StatusTag
      variant="neutral"
      size="sm"
      label="Keine aktiven Kanäle"
      color="#74808c"
      tooltipContent={noActiveChannelsTooltip(contact)}
    />
  {/if}
</span>

<style lang="less">
  .contact-channel-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.35rem;
    align-items: flex-start;
  }
</style>
